import React from "react";
import { NavLink } from "react-router-dom";
import "./InternalMenu.sass";

export const InternalMenu = () => {
  return (
    <div className="InternalMenu row">
      <nav>
        <ul>
          <li>
            <NavLink end to="/">
              Leyenda Caribe Resumen
            </NavLink>
          </li>
          <li>
            <NavLink to="/paquetes-y-ascensos">Paquetes y Ascensos</NavLink>
          </li>
          <li>
            <NavLink to="/precios">Precios</NavLink>
          </li>
          <li>
            <NavLink to="/categorias-y-premiacion">
              Categorías y Premiación
            </NavLink>
          </li>
          <li>
            <NavLink to="/rutas-y-reglamentacion/resumen">
              Rutas y Reglamentación
            </NavLink>
          </li>
          <li>
            <NavLink to="/2023/resultados">Resultados</NavLink>
          </li>
          <li>
            <NavLink to="/patrocinio">Patrocinio</NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};
